import TrackFalseSlider from "../../Components/Slider/Slider";
import React, { useState, useEffect } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import SelectForm from "../../Components/SelectForm/SelectForm";
import DateForm from "../../Components/DateForm/DateForm";
import {
  insertUpdateInitalDeposit,
  insertUpdatePaymentDetails,
  getPostPaymentDetails,
  configValue,
  getKycId,
  getConfigValues,
  CommonDropdownData,
} from "../../Helpers/APIEndPoints/EndPoints";
import notify from "../../Helpers/ToastNotification";
import moment from "moment";
import "./PaymentDetails.css";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import MemberRegistrationStatus, {
  MemberRegistrationModule,
} from "../../Components/MemberRegistrationStatus/MemberRegistrationStatus";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useLocation, useNavigate } from "react-router-dom";
import { DropdownTypeId } from "../../Helpers/Enums/DropdownTypeId";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { randomDate, randomNumber, randomString } from "../../Helpers/Common";
import { enableTestData } from "../../Helpers/Constants/Constants";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { Table } from "react-bootstrap";

const Payment = (props) => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [initialDeposit, setInitialDeposit] = useState(301);
  const [isDataAlreadySaved, setIsDataAlreadySaved] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };

  const [data, setData] = useState({
    accholdername: "",
    bankName: "",
    ifsc: "",
    accountNumber:null,
    transactionRef: null,
    amount: 0,
    transactionDate: null,
    typeoftransaction: null,
    statusId: 0,
    statusName: "",
    rejectedRemarks: [],
    HRHODApprovalDate:null
  });
  const [configvalue, setConfigvalue] = useState([]);
  const [showNext, setShowNext] = useState(false);
  const [monthlyDeclaration, setMonthlyDeclarations] = useState(300);
  const [payable, setPayable] = useState(601);
  const memberid =
    GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [disabled, setDisabled] = React.useState(false);
  const [initialdisabled, setInitialDisabled] = React.useState(false);
  const [error, setError] = React.useState<any>({});
  const [transactionOption, setTransactionOption] = React.useState([]);
  const { previous, next } = props;
  const [statusId, SetStatusId] = React.useState(0);
  const [bankDetails, setBankDetails] = React.useState([
    { name: "accountname", label: "Account Name", value: "" },
    { name: "accountnumber", label: "Account Number", value: "" },
    { name: "bankname", label: "Bank Name", value: "" },
    { name: "ifsccode", label: "IFSC Code", value: "" },
  ]);

  useEffect(() => {
    getConfigData();
    getTransactionData();
  }, []);


  useEffect(() => {
    if (transactionOption.length > 0) {
      getPaymentDetails();
    }
  }, [transactionOption]);

  const getKYCDetails = async () => {
    
    let url = `${getKycId}`;
    let requestBody = { MemberId: memberid };
    const getData = await APICall(url, requestBody);
   
    if (getData.Data != null) {
      let obj = {
        ...data,
        accholdername: getData.Data.AccountHolderName,
        bankName: getData.Data.BankName,
        ifsc: getData.Data.IFSCCode,
      };
    }
    return getData.Data;
  };

  const payAble = (key: any, value: any) => {
    if (key === "initaldeposit") {
      setInitialDeposit(value.target.value + 1);
      setPayable(monthlyDeclaration + value.target.value + 1);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    if (key === "monthlydeductions") {
      setMonthlyDeclarations(value.target.value);
      setPayable(initialDeposit + value.target.value);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    //setPayable(initialDeposit + monthlyDeclaration)
  };
  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const onSubmit = async () => {
    showLoader();
    if (isDataAlreadySaved) {
      setShowNext(true);
    } else {
      let param = {
        MemberId: memberid,
        InitialDeposit: initialDeposit,
        MonthlyDeductions: monthlyDeclaration,
      };
      
      const insertData = await APICall(insertUpdateInitalDeposit, param);
     
      if (insertData.Data != null) {
        setShowNext(true);
        showLoader();
        const alreadyInsert = await getPaymentDetails();
        // if(alreadyInsert.AccountHolderName != null){

        // }
      
        hideLoader();
      }
      else {
        notify(1, insertData.Message);
      }
    }
    hideLoader();
  };

  const onPyamentInsert = async () => {
    if (isDataAlreadySaved) {
      await next();
      return;
    }
    let errorObj = {};
    if (data.accholdername == "" || data.accholdername === null) {
      errorObj = {
        ...errorObj,
        [data.accholdername]: "This field is Required",
      };
    }
    if (data.bankName == "" || data.bankName === null) {
      errorObj = {
        ...errorObj,
        [data.bankName]: "This field is Required",
      };
    }
    if (data.ifsc == "" || data.ifsc === null) {
      errorObj = {
        ...errorObj,
        [data.ifsc]: "This field is Required",
      };
    }
    if (data.transactionRef === null) {
      errorObj = {
        ...errorObj,
        [data.transactionRef]: "This field is Required",
      };
    }
    if (data.typeoftransaction === null) {
      errorObj = {
        ...errorObj,
        [data.typeoftransaction]: "This field is Required",
      };
    }
    if (data.transactionDate === null) {
      errorObj = {
        ...errorObj,
        [data.transactionDate]: "This field is Required",
      };
    }
    if (data.transactionRef === null || data.transactionRef == "") {
      errorObj = {
        ...errorObj,
        [data.transactionRef]: "This field is Required",
      };
    }
    if (data.amount === null) {
      errorObj = {
        ...errorObj,
        [data.amount]: "This field is Required",
      };
    }
    if (data.accountNumber === null) {
      errorObj = {
        ...errorObj,
        [data.accountNumber]: "This field is Required",
      };
    }
    
    if (Object.keys(errorObj).length == 0) {
      const payment = await getPaymentDetails();
      if (payment != null) {
        showLoader();
        let param = {
          MemberId: memberid,
          AccountHolderName: data.accholdername,
          BankName: data.bankName,
          IFSCCode: data.ifsc,
          AccountNumber:data.accountNumber,
          TxnType: data.typeoftransaction.label,
          TxnReferenceNo: String(data.transactionRef),
          Amount: initialDeposit,
          TxnDate: moment(data.transactionDate).format("YYYY-MM-DD"),
        };
        const insertPayment = await APICall(insertUpdatePaymentDetails, param);
        if (insertPayment.Data != null) {
          let statusDetails = await next();
          await getPaymentDetails();
        } else {
          notify(1, insertPayment.Message);
        }
        hideLoader();
      } else {
        await next();
      }
    }
    setError(errorObj);
  };

  const getConfigData = async () => {
    let temp = bankDetails.map((bd) => bd.name); //["accountname", "accountnumber", "bankname", "ifsccode"];
    let arr = [];
    //temp.map(async (d) => {
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: temp });
    //arr.push(getdata.Data);
    arr = getdata.Data ? getdata.Data?.map((c) => c?.Value) : [];
    //});
    setConfigvalue(arr);
    if (getdata.Status === ApiStatus.OK && getdata?.Data?.length > 0) {
      const confData = getdata?.Data;
      const updatedBankDetails = bankDetails.map((detail) => {
        const configItem = confData.find(
          (config) => config.Key === detail.name
        );
        return {
          ...detail,
          value: configItem ? configItem.Value : detail.value,
        };
      });
      setBankDetails(updatedBankDetails);
    }
  };
  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };
  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };
  const getPaymentDetails = async () => {
    showLoader();
    
    let payment = `${getPostPaymentDetails}`;
    let requestBody = { MemberId: memberid };
    const getpayment = await APICall(payment, requestBody);
    if (getpayment.Data != null) {
      let obj = {
        accholdername: getpayment.Data.AccountHolderName,
        bankName: getpayment.Data.BankName,
        ifsc: getpayment.Data.IFSCCode,
        accountNumber: getpayment.Data.AccountNo,
        
        typeoftransaction: transactionOption.find(
          (d) => d.label === getpayment.Data.TxnType
        ),
        transactionRef: getpayment.Data.TxnReferenceNo,
        amount: getpayment.Data.TotalPayable,
        transactionDate: getpayment.Data.TxnDate,
        statusId: getpayment.Data.StatusId,
        statusName: getpayment.Data.StatusName,
        rejectedRemarks: getpayment.Data?.RejectedRemarks?.split("\n") || [],
        HRHODApprovalDate:null
      };

      SetStatusId(getpayment.Data.StatusId);
    
      getpayment.Data.InitialDeposit != null && setInitialDisabled(true);
      setInitialDeposit(getpayment.Data.InitialDeposit);
      setMonthlyDeclarations(getpayment.Data.MonthlyDeductions);
      setPayable(getpayment.Data.TotalPayable);

      const kycDetails = await getKYCDetails();
      
      if (kycDetails && kycDetails != null) {
        obj.accholdername = kycDetails.AccountHolderName;
        obj.bankName = kycDetails.BankName;
        obj.ifsc = kycDetails.IFSCCode;
        obj.accountNumber = kycDetails.AccountNo;
        obj.HRHODApprovalDate=kycDetails.HRHODApprovalDate;
        setData(obj);
      } else {
        setData(obj);
      }

      if (
        [
          ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
          ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
        ].includes(getpayment.Data.StatusId)
      ) {
        setIsDataAlreadySaved(false);
        setDisabled(false);
        setInitialDisabled(false);
      } else {
        const kycDetails = await getKYCDetails();
        
        if (kycDetails && kycDetails != null) {
          obj.accholdername = kycDetails.AccountHolderName;
          obj.bankName = kycDetails.BankName;
          obj.ifsc = kycDetails.IFSCCode;
          obj.accountNumber = kycDetails.AccountNo;
          obj.HRHODApprovalDate=kycDetails.HRHODApprovalDate;

          setData(obj);
        } else {
          setData(obj);
        }
        setIsDataAlreadySaved(true);
        setDisabled(true);
        setInitialDisabled(true);
      }
      // getpayment.Data.AccountHolderName != null && setDisabled(true);
    }
    hideLoader();
    return getpayment.Data;
  };

  const getTransactionData = async () => {
    const config = {
      dropdownName: "generic",
      GenericMasterTypeId: DropdownTypeId.PaymentTransactionType,
    };

    const result = await APICall(CommonDropdownData, config);

    if (result && result.Message == "Success" && result.Data.length > 0) {
      setTransactionOption(result.Data);
    }
  };

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    let newData = {
      accholdername: randomString(12),
      bankName: randomString(15),
      ifsc: `IFSC${randomNumber(1111111, 9999999)}`,
      accountNumber:data.accountNumber,
      typeoftransaction:
        transactionOption[randomNumber(0, transactionOption.length - 1)],
      transactionRef: randomNumber(111111111, 999999999),
      amount: randomNumber(1111, 9999),
      transactionDate: randomDate(new Date(2023, 9, 15), new Date()),
      statusId: data.statusId,
      statusName: data.statusName,
      rejectedRemarks: data.rejectedRemarks,
      HRHODApprovalDate:data.HRHODApprovalDate
    };
    setData(newData);
  };
  return (
    <>
      <div className="">
        <MemberRegistrationStatus
          statusId={statusId}
          memberRegistrationModule={MemberRegistrationModule.PaymentDetails}
          rejectReasons={data.rejectedRemarks}
        />
        {showNext === false && (
          <>
            <div className="col-lg-12 col-md-12 p-0">
              <div className="row">
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <label>Initial Deposit</label>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-sm-6 col-xs-6 "
                  style={{ marginTop: "20px" }}
                >
                  <TrackFalseSlider
                    min={300}
                    max={5000}
                    step={100}
                    valuetext={(e) => payAble("initaldeposit", e)}
                    value={initialDeposit}
                    disabled={initialdisabled}
                  />
                </div>
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <InputForm
                      placeholder={""}
                      value={initialDeposit}
                      disabled={initialdisabled}
                    />
                  </div>
                </div>
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <label style={{ fontSize: "smaller" }}>
                      (Entry fee Rs 1 + initial deposit)
                    </label>
                  </div>
                </div>
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <label>Monthly Declarations</label>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-sm-6 col-xs-6 "
                  style={{ marginTop: "20px" }}
                >
                  <TrackFalseSlider
                    min={300}
                    max={5000}
                    step={100}
                    valuetext={(e) => payAble("monthlydeductions", e)}
                    value={monthlyDeclaration}
                    disabled={initialdisabled}
                  />
                </div>
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <InputForm
                      placeholder={""}
                      value={monthlyDeclaration}
                      disabled={initialdisabled}
                    />
                  </div>
                </div>
                <div
                  className="col-lg-2 col-sm-2 col-xs-2 "
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <label style={{ fontSize: "smaller" }}>
                      (This amount will ne deducted monthly from your salary)
                    </label>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center col-lg-12">
                <div className="d-flex">
                  <label className="col-lg-5 mt-1">Total Payable</label>

                  <InputForm
                    value={initialDeposit
                      .toLocaleString("en-IN")}
                    // value={payable
                    //   .toString()
                    //   .replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,")}
                    placeholder={""}
                    isDisabled={initialdisabled}
                    readOnly={true}
                  />
                </div>
              </div>
              <div style={{ color: "#DB233A", textAlign: "center" }}>
                Note: Process to next after you successfully complete your
                payment
              </div>
              <div
                className=""
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#F6ECED",
                  padding: "15px",
                  margin: "10px 0",
                }}
              >
                <div className="my-2 table-bank-details-head">
                  Please pay ₹{initialDeposit} in the following bank details
                </div>
                <Table
                  borderless
                  hover
                  size="sm"
                  className="d-flex justify-content-center"
                >
                  <tbody>
                    {bankDetails.map((bd) => {
                      return (
                        <tr>
                          <td className="text-right">
                            <span
                              className="table-bank-details-data"
                              style={{ fontSize: "14px" }}
                            >
                              {bd.label}
                            </span>
                          </td>
                          <td>:</td>
                          <td className="text-left">
                            <span
                              className="table-bank-details-data"
                              style={{ fontSize: "14px" }}
                            >
                              {bd.value}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <div className="d-flex justify-content-end">
                <ButtonComponent
                  icon={"fas fa-arrow-left"}
                  value={"Back"}
                  onClick={previous}
                />
                <ButtonComponent
                  icon={"fa-solid"}
                  value={"Exit"}
                  style={{ marginLeft: "10px" }}
                  className="btn btn-primary"
                  onClick={() => navigate("/")}
                />
                <ButtonComponent
                  style={{ marginLeft: "10px" }}
                  icon={"fas fa-arrow-right"}
                  value={isDataAlreadySaved ? "Next" : "Save & Next"}
                  id={"saveBtn"}
                  onClick={onSubmit}
                />
              </div>
            </div>
          </>
        )}

        {showNext === true && (
          <>
            <div className="col-lg-12 col-md-12 p-0">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label onDoubleClick={testData}>Account Holder Name</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.accholdername}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("accholdername", value);
                      }}
                      isDisabled={data?.accholdername ? true : false}
                      onKeyPress={handleKeyNumbers}
                      maxlength={20}
                    />
                    {error[data.accholdername] && (
                      <p style={{ color: "red" }}>
                        {error[data.accholdername]}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Bank Name</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.bankName}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("bankName", value);
                      }}
                      isDisabled={data?.bankName ? true : false}
                      onKeyPress={handleKeyNumbers}
                      maxlength={20}
                    />
                    {error[data.bankName] && (
                      <p style={{ color: "red" }}>{error[data.bankName]}</p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>IFSC Code</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      maxlength={11}
                      value={data.ifsc}
                      onChange={(val: any) => {
                        let value = val.target.value;

                        // const regex = /^[A-Za-z]{4}\d{7}$/;
                        const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                        if (!regex.test(value)) {
                          setError({
                            ...error,
                            ["ifscValidation"]:
                              "Please enter a valid IFSC number.",
                          });
                        } else {
                          setError({ ...error, ["ifscValidation"]: "" });
                        }
                        onChange("ifsc", value);
                      }}
                      type="text"
                      isDisabled={data?.ifsc ? true : false}
                    />
                    {error[data.ifsc] ? (
                      <p style={{ color: "red" }}>{error[data.ifsc]}</p>
                    ) : error["ifscValidation"] ? (
                      <p style={{ color: "red" }}>{error["ifscValidation"]}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Account Number</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      maxlength={11}
                      value={data.accountNumber}
                      onChange={(val: any) => {
                        let value = val.target.value;

                        // const regex = /^[A-Za-z]{4}\d{7}$/;
                        const regex = /^[0-9]/;
                        if (!regex.test(value)) {
                          setError({
                            ...error,
                            ["accountNumberValidation"]:
                              "Please enter a valid Account number.",
                          });
                        } else {
                          setError({ ...error, ["accountNumberValidation"]: "" });
                        }
                        onChange("accountNumber", value);
                      }}
                      type="text"
                      isDisabled={data?.accountNumber ? true : false}
                    />
                    {error[data.accountNumber] ? (
                      <p style={{ color: "red" }}>{error[data.accountNumber]}</p>
                    ) : error["accountNumberValidation"] ? (
                      <p style={{ color: "red" }}>{error["accountNumberValidation"]}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Type of Transaction</label>
                    <sup>*</sup>
                    <SelectForm
                      value={data.typeoftransaction}
                      placeholder=""
                      options={transactionOption}
                      isDisabled={disabled}
                      onChange={(val: any) =>
                        onChange("typeoftransaction", val)
                      }
                    />
                    {error[data.typeoftransaction] && (
                      <p style={{ color: "red" }}>
                        {error[data.typeoftransaction]}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Transaction Reference</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={data.transactionRef}
                      onChange={(val: any) => {
                        let value = val.target.value;
                        onChange("transactionRef", value);
                      }}
                      type="text"
                      isDisabled={disabled}
                      // onKeyPress={handleKeyPress}
                      maxlength={20}
                      onWheel={(e) => e.target.blur()}
                    />
                    {error[data.transactionRef] && (
                      <p style={{ color: "red" }}>
                        {error[data.transactionRef]}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Amount</label>
                    <sup>*</sup>
                    <InputForm
                      placeholder={""}
                      value={initialDeposit
                        .toLocaleString("en-IN")}
                      onChange={(val: any) => {
                        let value = val.target.value
                          .toLocaleString("en-IN");
                        onChange("amount", value);
                      }}
                      isDisabled={disabled}
                      onKeyPress={handleKeyPress}
                      maxlength={20}
                      onWheel={(e) => e.target.blur()}
                    />
                    {error[data.amount] && (
                      <p style={{ color: "red" }}>{error[data.amount]}</p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 ">
                  <div className="form-group">
                    <label>Transaction Date</label>
                    <sup>*</sup>
                    <DateForm
                      isDisabled={disabled}
                      value={data.transactionDate}
                      onChange={(val: any) => onChange("transactionDate", val)}
                      placeholder="DD-MM-YYYY"
                      // disableFuture={true}
                      //disablePast={true}
                      minDate={data.HRHODApprovalDate}
                      maxDate={new Date()}
                    />
                    {error[data.transactionDate] && (
                      <p style={{ color: "red" }}>
                        {error[data.transactionDate]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <ButtonComponent
                  icon={"fas fa-arrow-left"}
                  value={"Back"}
                  onClick={() => setShowNext(false)}
                />
                <ButtonComponent
                  icon={"fa-solid"}
                  value={"Exit"}
                  style={{ marginLeft: "10px" }}
                  className="btn btn-primary"
                  onClick={() => navigate("/")}
                />
                {[
                  ApplicationStatus.MemberRegistrationModule_Draft,
                  ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
                  ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
                  ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
                  ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
                  // ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
                ].includes(statusId) && (
                  <ButtonComponent
                    style={{ marginLeft: "10px" }}
                    icon={"fas fa-arrow-right"}
                    value={isDataAlreadySaved ? "Next" : "Submit"}
                    id={"saveBtn"}
                    onClick={() => onPyamentInsert()}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default Payment;
